import { normalizeBoolean } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_DM_ABOUT_PAGE = createFcmConfig('dm_about_page', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
